export default {
    celular: '(##) #####-####',
    cep: '##.###-###',
    certidao: '###### ## ## #### # ##### ### ####### ##',
    cpf: '###.###.###-##',
    telefone: '(##) ####-####',
}